import BeefysOwnHomePage from "@faire/prototype-playground/workspace/rl/beefys-own-home";
import BrandHomeHeaderV1Page from "@faire/prototype-playground/workspace/rl/brand-home-header-v1";
import BrandPageHeaderSequencingPage from "@faire/prototype-playground/workspace/rl/brand-page-header-sequencing";
import BrandPageLookbookPage from "@faire/prototype-playground/workspace/rl/brand-page-lookbook";
import BrandPortalNavGridExplorationsPage from "@faire/prototype-playground/workspace/rl/brand-portal-nav-grid-explorations";
import EmilyLexTermsPage from "@faire/prototype-playground/workspace/rl/emily-lex-terms";
import FaireDirectBrandPortalPage from "@faire/prototype-playground/workspace/rl/faire-direct-brand-portal";
import FaireDirectLandingPageV0Page from "@faire/prototype-playground/workspace/rl/faire-direct-landing-page-v0";
import FdCommissionRequestPage from "@faire/prototype-playground/workspace/rl/fd-commission-request";
import BrandRefinementFontPressureTestingPage from "@faire/prototype-playground/workspace/rl/font-pressure-testing";
import GumballPoodleFdLandingPage from "@faire/prototype-playground/workspace/rl/gumball-poodle-fd-landing";
import KendrickHomePage from "@faire/prototype-playground/workspace/rl/kendrick-home";
import LeLisHomePage from "@faire/prototype-playground/workspace/rl/le-lis-home";
import LeLisWebsiteBuilderPage from "@faire/prototype-playground/workspace/rl/lelis-website-builder";
import LeLisWholesalePage from "@faire/prototype-playground/workspace/rl/lelis-wholesale";
import LemonadeShoesHomePage from "@faire/prototype-playground/workspace/rl/lemonade-shoes-home";
import MyShopStoryPage from "@faire/prototype-playground/workspace/rl/my-shop-story";
import NobleMicksHomePage from "@faire/prototype-playground/workspace/rl/noble-micks-home";
import OraCacaoHomePage from "@faire/prototype-playground/workspace/rl/ora-cacao-home";
import PfCandleHomeV2Page from "@faire/prototype-playground/workspace/rl/pfcandle-home-v2";
import { EntryPage as PfCandleHomeV2EntryPage } from "@faire/prototype-playground/workspace/rl/pfcandle-home-v2/EntryPage";
import PfCandleModuleGalleryPage from "@faire/prototype-playground/workspace/rl/pfcandle-home-v2/ModuleGallery";
import PfCandleHomeV3Page from "@faire/prototype-playground/workspace/rl/pfcandle-home-v3";
import PfCandleWholesalePage from "@faire/prototype-playground/workspace/rl/pfcandle-wholesale";
import PlaygroundDemoReelPage from "@faire/prototype-playground/workspace/rl/playground-demo-reel";
import PrimitivesByKathyFdHomePage from "@faire/prototype-playground/workspace/rl/primitives-by-kathy-fd-home";
import PublicGoodsWholesalePage from "@faire/prototype-playground/workspace/rl/public-goods-wholesale";
import SoftiesBrandHomePage from "@faire/prototype-playground/workspace/rl/softies-home";
import SumaHomePage from "@faire/prototype-playground/workspace/rl/suma-home";
import SumaWebsiteLinkPage from "@faire/prototype-playground/workspace/rl/suma-website-link";
import SumaWebsiteLinkV2Page from "@faire/prototype-playground/workspace/rl/suma-website-link-v2";
import SweetWinkHomePage from "@faire/prototype-playground/workspace/rl/sweet-wink-home";
import { HalloweenCollectionPage } from "@faire/prototype-playground/workspace/rl/sweet-wink-home/HalloweenCollection";
import VanillaWebsiteConfiguratorPage from "@faire/prototype-playground/workspace/rl/vanilla-website-configurator";
import ViveranoOrganicsHomePage from "@faire/prototype-playground/workspace/rl/viverano-organics-home";
import ViveranoWholesalePage from "@faire/prototype-playground/workspace/rl/viverano-wholesale";
import AngelDearWebsiteBuilderPage from "@faire/prototype-playground/workspace/rl/website-builder/angel-dear";
import KendrickHomeWebsiteBuilderPage from "@faire/prototype-playground/workspace/rl/website-builder/kendrick-home";
import WebsiteBuilderSystemPage from "@faire/prototype-playground/workspace/rl/website-builder/system";
import ToysmithWebsiteBuilderPage from "@faire/prototype-playground/workspace/rl/website-builder/toysmith";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const CompassLayout = lazy(() =>
  import("../../components/compass/CompassLayout").then((m) => ({
    default: m.CompassLayout,
  }))
);

const AllIdeas2Page = withCompass(() => import("../../pages/AllIdeas2Page"));
const BjornQornPDP = withCompass(
  () => import("../../pages/snacks/BjornQornPDP")
);
const BrandCartOverlayConceptPage = withCompass(
  () => import("../../pages/BrandCartOverlayConceptPage")
);

const BrandPage = withCompass(() => import("../../pages/BrandPage"));

const BrandPageLoggedOut = lazy(() => import("../../pages/BrandPageLoggedOut"));

const BrandPageV2 = withCompass(() => import("../../pages/BrandPageV2"));
const BrandPageV3 = withCompass(() => import("../../pages/BrandPageV3Page"));
const BrandPageV4 = withCompass(() => import("../../pages/BrandPageV4Page"));
const PfCandleFd = withCompass(() => import("../../pages/PfCandleFdPage"));
const PfCandleHome = withCompass(() => import("../../pages/PfCandleHomePage"));

const BrandPageWithCart = withCompass(
  () => import("../../pages/BrandPageWithCart")
);
const CartPage = withCompass(() => import("../../pages/CartPage"));
const DataDemoPage = withCompass(() => import("../../pages/DataDemoPage"));
const CartR2RLPage = withCompass(() => import("../../pages/CartR2RLPage"));
const CheckoutPage = withCompass(() => import("../../pages/CheckoutPage"));

const CompassChatBehaviorPage = withCompass(
  () => import("../../pages/CompassChatBehaviorPage")
);
const CompassContainedHomePage = withCompass(
  () => import("../../pages/CompassContainedHomePage")
);

const CompassDrawerOverlayDemoPage = withCompass(
  () => import("../../pages/CompassDrawerOverlayDemoPage")
);
const FletcherLuPDP = withCompass(
  () => import("../../pages/snacks/FletcherLuPDP")
);
const IdeaDetailR3Page = withCompass(
  () => import("../../pages/IdeaDetailR3Page")
);
const IdeasR3Page = withCompass(() => import("../../pages/IdeasR3Page"));
const IndexExplorationPage = lazy(
  () => import("../../pages/IndexExplorationPage")
);
const IndexExplorationPageV2 = lazy(
  () => import("../../pages/IndexExplorationPageV2")
);
const MisoCaramelPopcornPDP = withCompass(
  () => import("../../pages/snacks/MisoCaramelPopcornPDP")
);
const MomofukuPDP = withCompass(() => import("../../pages/snacks/MomofukuPDP"));
const MultiBrandCartDemo = withCompass(
  () => import("../../pages/MultiBrandCartDemo")
);
const NewPage = withCompass(() => import("../../pages/NewPage"));
const NewRetailerPage = withCompass(
  () => import("../../pages/NewRetailerPage")
);
const OrderConfirmationPage = withCompass(
  () => import("../../pages/OrderConfirmationPage")
);
const PdpRefreshPage = withCompass(() => import("../../pages/PdpRefreshPage"));
const ProductDetailPage = withCompass(
  () => import("../../pages/ProductDetailPage")
);
const ProductDetailPageV2 = withCompass(
  () => import("../../pages/ProductDetailPageV2")
);
const ProductDetailPageV2WithAI = withCompass(
  () => import("../../pages/ProductDetailPageV2WithAI")
);
const ProductDetailPageV2WithAIInline = withCompass(
  () => import("../../pages/ProductDetailPageV2WithAIInline")
);
const ProductDetailPageWithDrawer = withCompass(
  () => import("../../pages/ProductDetailPageWithDrawer")
);
const ProductDetailPageWithDrawerLeft = withCompass(
  () => import("../../pages/ProductDetailPageWithDrawerLeft")
);
const ProductDetailPageWithOverlayPush = withCompass(
  () => import("../../pages/ProductDetailPageWithOverlayPush")
);
const SavedBoardsR2RLPage = withCompass(
  () => import("../../pages/SavedBoardsR2RLPage")
);
const SearchResultsPage = withCompass(
  () => import("../../pages/SearchResultsPage")
);
const SearchResultsPageV2 = withCompass(
  () => import("../../pages/SearchResultsPageV2")
);
const SourdoughPretzelsPDP = withCompass(
  () => import("../../pages/snacks/SourdoughPretzelsPDP")
);
const ThemeDetailPage = withCompass(
  () => import("../../pages/ThemeDetailPage")
);
const ThemeDetailR2RLPage = withCompass(
  () => import("../../pages/ThemeDetailR2RLPage")
);
const ThemesPage = withCompass(() => import("../../pages/ThemesPage"));
const ThemesR2RLPage = withCompass(() => import("../../pages/ThemesR2RLPage"));
const VanillaBeanMarshmallowsPDP = withCompass(
  () => import("../../pages/snacks/VanillaBeanMarshmallowsPDP")
);
const CategoryPage = withCompass(() => import("../../pages/CategoryPage"));
const GlobalNavLayout = lazy(() => import("../../components/GlobalNavLayout"));
const GridGutterProvider = lazy(() =>
  import("../../contexts/GridGutterContext").then((m) => ({
    default: m.GridGutterProvider,
  }))
);
const CompassPDPRebuild = lazy(() => import("../../pages/CompassPDPRebuild"));
const MobileWebCanvasPage = lazy(
  () => import("../../pages/MobileWebCanvasPage")
);
const TemplatePage = withCompass(() => import("../../pages/TemplatePage"));
const IdeasV1Page = withCompass(() => import("../../pages/IdeasV1Page"));
const IdeasV1HubPage = withCompass(() => import("../../pages/IdeasV1HubPage"));
const SavedBoardV1Page = withCompass(
  () => import("../../pages/SavedBoardV1Page")
);
const IdeaDetailV1HubPage = withCompass(
  () => import("../../pages/IdeaDetailV1HubPage")
);
const SidecartToCartPage = withCompass(
  () => import("../../pages/SidecartToCartPage")
);
const AtlasPage = lazy(() => import("../../pages/brand-storefronts/AtlasPage"));
const OlipopWholesalePage = lazy(
  () => import("../../pages/BrandStorefrontsPage")
);
const LayermorWholesaleLandingPage = lazy(
  () => import("../../pages/LayermorWholesaleLandingPage")
);
const LayermorLandingKitOfPartsPage = lazy(
  () => import("../../pages/LayermorLandingKitOfPartsPage")
);
const LayermorHomePage = lazy(() => import("../../pages/LayermorHomePage"));
const LayermorBrandPage = withCompass(
  () => import("../../pages/LayermorBrandPage")
);
const PrimitivesByKathyHomePage = lazy(
  () => import("../../pages/PrimitivesByKathyHomePage")
);
const PrimitivesByKathyWholesalePage = lazy(
  () => import("../../pages/PrimitivesByKathyWholesalePage")
);
const OlipopBrandPage = withCompass(
  () => import("../../pages/OlipopBrandPage")
);
const OraCacaoBrandPage = withCompass(
  () => import("../../pages/OraCacaoBrandPage")
);
const OraCacaoConnectPage = lazy(
  () => import("../../workspace/rl/ora-cacao-connect/Page")
);
const DamagedAndMissingPage = lazy(
  () => import("../../pages/DamagedAndMissingPage")
);
const DamagedAndMissingIssuesPage = lazy(
  () => import("../../pages/DamagedAndMissingIssuesPage")
);
const FaireDirectSignupControlPage = lazy(
  () => import("../../workspace/rl/faire-direct-signup-control/Page")
);

export function RyanLeeRoutes() {
  return (
    <CompassLayout>
      <Switch>
        <Route path="/rl/template" component={TemplatePage} />
        <Route path="/rl/new-page" component={NewPage} />
        <Route
          exact
          path="/rl/compasspanelexplorations"
          component={NewRetailerPage}
        />
        <Route
          path="/rl/compasspanelexplorations/brands"
          component={MultiBrandCartDemo}
        />
        <Route path="/rl/compasspanelexplorations/cart" component={CartPage} />
        <Route
          path="/rl/compasspanelexplorations/brand/:brandSlug"
          component={BrandPageWithCart}
        />
        <Route
          path="/rl/brand/:brandSlug/logged-out"
          component={BrandPageLoggedOut}
        />
        <Route path="/rl/brand/:brandSlug/v2" component={BrandPageV2} />
        <Route
          path="/rl/brand-home-modules"
          component={PfCandleModuleGalleryPage}
        />
        <Route path="/rl/brand-v3" component={BrandPageV3} />
        <Route path="/rl/brand-v4" component={BrandPageV4} />
        <Route path="/rl/pfcandle-fd" component={PfCandleFd} />
        <Route
          path="/rl/pfcandle-brand-home-v3"
          component={PfCandleHomeV2Page}
        />
        <Route path="/rl/pfcandle-home" component={PfCandleHome} />
        {/* Legacy URL — kept so existing links keep working. */}
        <Route path="/rl/pfcandle-home-v2" component={PfCandleHomeV2Page} />
        <Route
          path="/rl/pfcandle-home-v2-entry"
          component={PfCandleHomeV2EntryPage}
        />
        <Route path="/rl/suma-home" component={SumaHomePage} />
        <Route
          path="/rl/primitives-by-kathy-fd-home"
          component={PrimitivesByKathyFdHomePage}
        />
        <Route path="/rl/brand/:brandSlug" component={BrandPage} />
        <Route path="/rl/search-results" component={SearchResultsPage} />
        <Route path="/rl/search-results-v2" component={SearchResultsPageV2} />
        <Route exact path="/rl/themes" component={ThemesPage} />
        <Route exact path="/rl/themes/ideas" component={ThemesPage} />
        <Route path="/rl/themes/all-ideas2" component={AllIdeas2Page} />
        <Route path="/rl/themes/:themeId" component={ThemeDetailPage} />
        <Route exact path="/rl/themes-r2-rl" component={ThemesR2RLPage} />
        <Route exact path="/rl/themes-r2-rl/ideas" component={ThemesR2RLPage} />
        <Route exact path="/rl/themes-r2-rl/cart" component={CartR2RLPage} />
        <Route
          path="/rl/themes-r2-rl/cart/:brandToken"
          component={CartR2RLPage}
        />
        <Route
          exact
          path="/rl/themes-r2-rl/saved"
          component={SavedBoardsR2RLPage}
        />
        <Route
          path="/rl/themes-r2-rl/saved/:boardId"
          component={SavedBoardsR2RLPage}
        />
        <Route
          path="/rl/themes-r2-rl/:themeId"
          component={ThemeDetailR2RLPage}
        />
        <Route exact path="/rl/ideas-r3" component={IdeasR3Page} />
        <Route exact path="/rl/ideas-r3/ideas" component={IdeasR3Page} />
        <Route path="/rl/ideas-r3/:themeId" component={IdeaDetailR3Page} />
        <Route
          path="/rl/category/:categoryName"
          render={() => (
            <GlobalNavLayout>
              <CategoryPage contentOnly />
            </GlobalNavLayout>
          )}
        />
        <Route
          path="/rl/index-exploration"
          render={() => (
            <GridGutterProvider>
              <IndexExplorationPage />
            </GridGutterProvider>
          )}
        />
        <Route
          path="/rl/index-exploration-v2"
          component={IndexExplorationPageV2}
        />
        <Route
          path="/rl/compass-contained/home"
          component={CompassContainedHomePage}
        />
        <Route
          path="/rl/compass-drawer-overlay-demo"
          component={CompassDrawerOverlayDemoPage}
        />
        <Route
          path="/rl/compass-chat-behavior"
          component={CompassChatBehaviorPage}
        />
        <Route exact path="/rl/pdp" component={ProductDetailPage} />
        <Route path="/rl/pdp-v2" component={ProductDetailPageV2} />
        <Route
          path="/rl/pdp-v2-with-ai"
          component={ProductDetailPageV2WithAI}
        />
        <Route
          path="/rl/pdp-v2-with-ai-inline"
          component={ProductDetailPageV2WithAIInline}
        />
        <Route
          path="/rl/pdp-with-drawer"
          component={ProductDetailPageWithDrawer}
        />
        <Route
          path="/rl/pdp-with-overlay-push"
          component={ProductDetailPageWithOverlayPush}
        />
        <Route path="/rl/pdp/bjornqorn" component={BjornQornPDP} />
        <Route
          path="/rl/pdp/fletcher-lu-seed-cracker"
          component={FletcherLuPDP}
        />
        <Route
          path="/rl/pdp/sourdough-pretzels"
          component={SourdoughPretzelsPDP}
        />
        <Route
          path="/rl/pdp/momofuku-chili-chocolate"
          component={MomofukuPDP}
        />
        <Route
          path="/rl/pdp/miso-caramel-popcorn"
          component={MisoCaramelPopcornPDP}
        />
        <Route
          path="/rl/pdp/vanilla-bean-marshmallows"
          component={VanillaBeanMarshmallowsPDP}
        />
        <Route
          path="/rl/pdp-with-drawer-left"
          component={ProductDetailPageWithDrawerLeft}
        />
        <Route path="/rl/checkout" component={CheckoutPage} />
        <Route
          path="/rl/order-confirmation"
          component={OrderConfirmationPage}
        />
        <Route path="/rl/pdp-refresh" component={PdpRefreshPage} />
        <Route
          path="/rl/brand-cart-overlay-concept"
          component={BrandCartOverlayConceptPage}
        />
        <Route path="/rl/cart" component={CartPage} />
        <Route path="/rl/mobile-web-canvas" component={MobileWebCanvasPage} />
        <Route path="/rl/compass-pdp-rebuild" component={CompassPDPRebuild} />
        <Route path="/rl/data-demo" component={DataDemoPage} />
        <Route exact path="/rl/ideas-v1" component={IdeasV1Page} />
        <Route exact path="/rl/ideas-v1/ideas" component={IdeasV1HubPage} />
        <Route
          path="/rl/ideas-v1/saved/:boardId"
          component={SavedBoardV1Page}
        />
        <Route path="/rl/ideas-v1/:themeId" component={IdeaDetailV1HubPage} />
        <Route path="/rl/sidecart-to-cart" component={SidecartToCartPage} />
        <Route path="/rl/brand-storefronts" component={AtlasPage} />
        <Route
          path="/rl/layermor-wholesale-landing"
          component={LayermorWholesaleLandingPage}
        />
        <Route
          path="/rl/layermor-landing-kit"
          component={LayermorLandingKitOfPartsPage}
        />
        <Route path="/rl/layermor-home" component={LayermorHomePage} />
        <Route path="/rl/layermor-brand-page" component={LayermorBrandPage} />
        <Route
          path="/rl/primitives-by-kathy-home"
          component={PrimitivesByKathyHomePage}
        />
        <Route
          path="/rl/primitives-by-kathy-wholesale"
          component={PrimitivesByKathyWholesalePage}
        />
        <Route path="/rl/olipop-brand-page" component={OlipopBrandPage} />
        <Route path="/rl/olipop-wholesale" component={OlipopWholesalePage} />
        <Route path="/rl/ora-cacao-brand-page" component={OraCacaoBrandPage} />
        <Route path="/rl/ora-cacao-connect" component={OraCacaoConnectPage} />
        <Route
          path="/rl/faire-direct-signup-control"
          component={FaireDirectSignupControlPage}
        />
        <Route
          path="/rl/damaged-and-missing/issues"
          component={DamagedAndMissingIssuesPage}
        />
        <Route
          path="/rl/damaged-and-missing"
          component={DamagedAndMissingPage}
        />
        <Route path="/rl/beefys-own-home" component={BeefysOwnHomePage} />
        <Route
          path="/rl/brand-home-header-v1"
          component={BrandHomeHeaderV1Page}
        />
        <Route
          path="/rl/brand-page-lookbook"
          component={BrandPageLookbookPage}
        />
        <Route
          path="/rl/brand-portal-nav-grid-explorations"
          component={BrandPortalNavGridExplorationsPage}
        />
        <Route path="/rl/emily-lex-terms" component={EmilyLexTermsPage} />
        <Route
          path="/rl/faire-direct-brand-portal"
          component={FaireDirectBrandPortalPage}
        />
        <Route
          path="/rl/faire-direct-landing-page-v0"
          component={FaireDirectLandingPageV0Page}
        />
        <Route
          path="/rl/fd-commission-request"
          component={FdCommissionRequestPage}
        />
        <Route
          path="/rl/gumball-poodle-fd-landing"
          component={GumballPoodleFdLandingPage}
        />
        <Route
          path="/rl/font-pressure-testing"
          component={BrandRefinementFontPressureTestingPage}
        />
        <Route path="/rl/le-lis-home" component={LeLisHomePage} />
        <Route path="/rl/lelis-wholesale" component={LeLisWholesalePage} />
        <Route
          path="/rl/viverano-wholesale"
          component={ViveranoWholesalePage}
        />
        <Route
          path="/rl/lemonade-shoes-home"
          component={LemonadeShoesHomePage}
        />
        <Route path="/rl/noble-micks-home" component={NobleMicksHomePage} />
        <Route path="/rl/ora-cacao-home" component={OraCacaoHomePage} />
        {/* Legacy URL — kept so existing links keep working. */}
        <Route path="/rl/pfcandle-home-v3" component={PfCandleHomeV3Page} />
        <Route
          path="/rl/pfcandle-wholesale"
          component={PfCandleWholesalePage}
        />
        <Route
          path="/rl/pfcandle-wholesale-login-v3"
          component={PfCandleHomeV3Page}
        />
        <Route
          path="/rl/public-goods-wholesale"
          component={PublicGoodsWholesalePage}
        />
        <Route path="/rl/my-shop-story" component={MyShopStoryPage} />
        <Route
          path="/rl/playground-demo-reel"
          component={PlaygroundDemoReelPage}
        />
        <Route path="/rl/softies-home" component={SoftiesBrandHomePage} />
        <Route path="/rl/kendrick-home" component={KendrickHomePage} />
        <Route
          path="/rl/suma-website-link-v2"
          component={SumaWebsiteLinkV2Page}
        />
        <Route
          path="/rl/lelis-website-builder"
          component={LeLisWebsiteBuilderPage}
        />
        <Route
          path="/rl/toysmith-website-builder"
          component={ToysmithWebsiteBuilderPage}
        />
        <Route
          path="/rl/website-builder-system"
          component={WebsiteBuilderSystemPage}
        />
        <Route
          path="/rl/kendrick-home-website-builder"
          component={KendrickHomeWebsiteBuilderPage}
        />
        <Route
          path="/rl/angel-dear-website-builder"
          component={AngelDearWebsiteBuilderPage}
        />
        <Route
          path="/rl/brand-page-header-sequencing"
          component={BrandPageHeaderSequencingPage}
        />
        <Route path="/rl/suma-website-link" component={SumaWebsiteLinkPage} />
        <Route exact path="/rl/sweet-wink-home" component={SweetWinkHomePage} />
        <Route
          path="/rl/vanilla-website-configurator"
          component={VanillaWebsiteConfiguratorPage}
        />
        <Route
          path="/rl/viverano-organics-home"
          component={ViveranoOrganicsHomePage}
        />
        <Route
          path="/rl/sweet-wink-home/halloween"
          component={HalloweenCollectionPage}
        />
      </Switch>
    </CompassLayout>
  );
}

export const slug = "rl";
